import SearchableField from './SearchableFieldContainer';

export default SearchableField;
